import React from 'react';

const PublicProfilePageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/profile',
			exact: true,
			component: React.lazy(() => import('./PublicProfilePage')),
		},
	],
};

export default PublicProfilePageConfig;
